<template>
  <v-dialog
    v-model="opened"
    @keydown.esc="$emit('update:opened', false)"
    scrollable
    width="800"
    persistent
  >
    <v-card>
      <v-card-title>
        <span
          class="title text-xs-left"
          v-if="selectedQuestionnaires.length === 1"
          >Notify Status Change to
          {{ newCustomStatus.firm_user_display_status }}</span
        >
        <span class="title text-xs-left" v-else
          >Notify Status Change ({{ selectedQuestionnaires.length }})</span
        >
        <v-spacer />
      </v-card-title>
      <v-card-text class="text-xs-left">
        <div class="font-weight-bold">
          Preview Client Instruction
          <v-tooltip bottom>
            <v-icon size="15" class="ml-1" slot="activator"> info </v-icon>
            <span
              >You can edit this under <b>Custom Statuses</b> tab in
              <b>Firm Setting</b></span
            >
          </v-tooltip>
        </div>
        <v-card class="text-xs-left pa-4 mb-4 card">
          <v-layout>
            <h2>
              <span
                >{{ selectedQuestionnaires[0].tax_year }}
                {{ selectedQuestionnaires[0].formatted_name }}</span
              >
            </h2>
            <v-spacer />
            <h2>
              <span class="status-label">{{
                newCustomStatus.client_display_status
              }}</span>
            </h2>
          </v-layout>
          <v-layout class="pt-2">
            <span
              class="instruction"
              v-html="newCustomStatus.client_instruction"
            />
          </v-layout>
        </v-card>
        <v-layout column>
          <span class="font-weight-bold mb-2">Email </span>
          <span>Subject</span>
          <v-text-field
            v-model="customEmailSubject"
            class="default-input"
            :placeholder="emailDefaultSubject"
            solo
          />
          <span>Body</span>
          <v-textarea
            v-model="customEmailMessage"
            class="default-input"
            :placeholder="emailDefaultMessage"
            solo
            rows="10"
          />
          <v-switch
            label="Send SMS Message?"
            class="pa-0 ma-0"
            v-model="sendSmsMessage"
          />
          <span class="font-weight-bold"
            >SMS Notification
            <v-tooltip bottom>
              <v-icon size="15" class="ml-1" slot="activator"> info </v-icon>
              <span
                >The message will be sent if the client has a phone number and
                has opted in to receive SMS notification. The message will also
                contain a link</span
              >
            </v-tooltip>
          </span>
          <v-textarea
            v-model="customSmsMessage"
            class="default-input"
            :placeholder="smsDefaultMessage"
            solo
          />
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          class="primary text-capitalize"
          @click="sendCustomStatusChange()"
        >
          Send
        </v-btn>
        <v-btn
          class="error--text text-capitalize"
          outline
          @click="$emit('update:opened', false)"
        >
          Do not send
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import API from '@/api';
import { mapGetters } from 'vuex';

export default {
  props: {
    opened: {
      type: Boolean,
    },

    selectedQuestionnaires: {
      type: Array,
      default: [],
    },

    newCustomStatus: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      customEmailSubject: '',
      customEmailMessage: '',
      sendSmsMessage: true,
      customSmsMessage: '',
      emailDefaultSubject:
        'Update regarding {questionnaire_name} for {questionnaire_year}:',
      emailDefaultMessage:
        'Hi {client_fname}!\n\nThere has been an new status regarding the {questionnaire_year} {questionnaire_name}:',
      emailDefaultMessageFooter: 'Click the below button to view the update.',
      smsDefaultMessage:
        '{firm_name}: Hi {client_fname}, there has been an update regarding the {questionnaire_year} {questionnaire_name}:',
    };
  },

  computed: {
    ...mapGetters({
      currentUser: 'user',
    }),
  },

  methods: {
    isEmpty,
    moment,
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    reset() {
      this.customEmailSubject = `${this.emailDefaultSubject} ${this.newCustomStatus.client_display_status}`;
      this.customEmailMessage = `${this.emailDefaultMessage}\n\n<h2>${this.newCustomStatus.client_display_status}</h2><i>${this.newCustomStatus.client_instruction}</i>\n\n${this.emailDefaultMessageFooter}`;
      this.customSmsMessage = `${this.smsDefaultMessage} ${this.newCustomStatus.client_display_status}`;
    },
    async sendCustomStatusChange() {
      try {
        const response = await API.questionnaire.sendCustomStatusChange({
          questionnaireIds: this.selectedQuestionnaires.map(q => q.id),
          customEmailSubject: this.customEmailSubject,
          customEmailMessage: this.customEmailMessage,
          customSmsMessage: this.sendSmsMessage ? this.customSmsMessage : null,
        });
        if (response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: response.data.error,
          });
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message: 'You have sent the status update.',
          });
          this.$emit('update:opened', false);
          this.$emit('refresh-questionnaires');
        }
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message:
            "We couldn't send the status update. Please refresh the page and try again.",
          errorToSend: e,
          userEmail: this.currentUser.email,
        });
      }
    },
  },
  watch: {
    opened(newVal) {
      if (newVal) {
        this.reset();
      }
    },
  },
};
</script>
<style lang="postcss" scoped>
.status-container {
  padding-left: 16px;
  margin-left: 2px;
  border-left: 4px solid #2196f3;
}
.status-label {
  color: #2196f3;
}
.instruction {
  font-size: 16px;
}
.card {
  box-shadow: 0 1px 4px 0px rgba(0, 0, 0, 0.2);
}
</style>
